import React from "react";
import AppButton from "../Button";
import "../../../Styles/components/load-more-action.scss";

export default function LoadMoreAction({
  canLoadMore = true,
  className = "",
  disabled = false,
  loading = false,
  onClick,
  label = "Load More",
  loadingLabel = "Loading...",
  summary = "",
}) {
  const wrapperClassName = [
    "load-more-action",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className={wrapperClassName}>
      {summary ? (
        <p className="load-more-action__summary">{summary}</p>
      ) : (
        <span aria-hidden="true" />
      )}
      <AppButton
        type="button"
        variant="primary"
        disabled={!canLoadMore || disabled}
        loading={loading && !label}
        onClick={onClick}
      >
        {loading ? loadingLabel : label}
      </AppButton>
      <span aria-hidden="true" />
    </div>
  );
}
